import type React from 'react';

const RightClickMenu: React.FC = () => {
  return null;
};

export default RightClickMenu;
